import React from 'react';
import { IMaskInput } from 'react-imask';

const InputPhone = ({ ...props }) => {
  return (
    <IMaskInput
      type="numeric"
      mask="(00) 00000-0000"
      placeholder='(__) _____.____'
      autoComplete='on'
      radix=""
      unmask={true} // true|false|'typed'
      {...props}
      className={`${props.className} block w-full autofill:bg-yellow-600 rounded border-0 py-2 pl-8 pr-10 ring-1 ring-gray-400 placeholder:text-gray-300 placeholder:font-normal font-extrabold text-xl focus:ring-2 focus:ring-gray-500 transition-all ease-in-out duration-200 disabled:bg-gray-200`}
    />
  );
};

export default InputPhone;
